<template>
    <section class="heightContainer">
        <b-overlay :show="loading" no-wrap opacity="1">
        </b-overlay>
        <section class="rtaTitle">
            <img :src="require('@/assets/rta/detailsRta.svg')" alt="Details RTA" />
            <span>Detalhamento da RTA</span>
        </section>
        <section class="rtaDetailsContainer">
            <section class="generalInfo" v-show="showDetailsInfo">
                <CustomInputRta type="text" class="code" id="code" :modelRef="detailsRta.code" :editable="false"
                    title="Gerado pelo Sistema" label="Código RTA" :inputFunc="event => {
                        this.detailsRta.code = event.target.value
                    }" />

                <CustomInputRta type="select" class="ind" id="indicator" :modelRef="detailsRta.indicatorId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Indicador *" :inputFunc="event => {
                        this.detailsRta.indicatorId = Number(event.target.value)
                    }" :optList="this.allIndicators" optValue="id" optDisplay="indicatorName" />

                <CustomInputRta type="select" class="proc" id="proc" :modelRef="detailsRta.processId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Processo *" :optList="this.process" optValue="id" optDisplay="description" :inputFunc="event => {
                        this.detailsRta.processId = Number(event.target.value)
                    }" />

                <CustomInputRta type="select" class="prod" id="prod" :modelRef="detailsRta.productId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Produto" :optList="products" optValue="id" optDisplay="description" :inputFunc="event => {
                        this.detailsRta.productId = Number(event.target.value)
                    }" />

                <CustomInputRta type="select" class="resp" id="resp" :modelRef="detailsRta.mainRespId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Responsável *" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                        this.detailsRta.mainRespId = Number(event.target.value)
                    }" />

                <div class="auxResp">
                    <span>Participantes do Tratamento</span>
                    <div v-if="this.detailsRta.auxResponsibles && this.detailsRta.auxResponsibles != ''">
                        <p v-for="(aux, auxIdx) in this.detailsRta.auxResponsibles" :key="auxIdx">{{ aux.UserName }}</p>
                    </div>
                </div>

                <CustomInputRta type="date" class="creation" id="creation" :modelRef="detailsRta.formattedCreationDate"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Data de Abertura *" :inputFunc="event => {
                        this.detailsRta.formattedCreationDate = event.target.value
                    }" />

                <CustomInputRta type="date" class="deadline" id="deadline" :modelRef="detailsRta.formattedDeadline"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Prazo *" :inputFunc="event => {
                        this.detailsRta.formattedDeadline = event.target.value
                    }" />

                <CustomInputRta type="select" class="equip" id="equip" :modelRef="detailsRta.equipmentId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Equipamento" :optList="equipment" optValue="id" optDisplay="description" :inputFunc="event => {
                        this.detailsRta.equipmentId = Number(event.target.value)
                    }" />

                <CustomInputRta type="text" class="trigger" id="trigger" :modelRef="detailsRta.trigger"
                    :editable="false" label="Gatilho" :inputFunc="event => {
                        this.detailsRta.trigger = event.target.value
                    }" />

                <CustomInputRta type="select" class="accResp" id="accResp" :modelRef="detailsRta.efficiencyRespId"
                    :editable="(pagePermissions.isManualRta || pagePermissions.isMainResp || pagePermissions.isAuxResp) && disableEdit == false"
                    label="Resp. Eficácia *" :optList="usersResps" optValue="id" optDisplay="name" :inputFunc="event => {
                        this.detailsRta.efficiencyRespId = Number(event.target.value)
                    }" />
            </section>

            <section class="openFcas">
                <b-form-textarea rows="2" no-resize :v-model="detailsRta.desc" :value="detailsRta.desc"
                    id="textares-rta" @input="text => detailsRta.desc = text">
                </b-form-textarea>

                <button v-if="pagePermissions.isManual == false"
                    @click="() => this.$bvModal.show('fcaViewModal')">Visualizar FCAs Vinculados</button>
            </section>

            <button @click="toggleDetailsInfo" class="showDetailsBtn">
                <span>Ocultar Detalhes</span>
                <b-icon-chevron-expand />
            </button>

            <section class="dealSection">
                <b-tabs content-class="customTabsClassContainerRta" class="customTabsClassRta">
                    <b-tab title="Identificação de Causa Raiz" active>
                        <section class="respContainer">
                            <CustomInputRta type="text" id="effectReason" :modelRef="reasonDetails.effect"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Efeito/Anomalia" :blue-class="true" :inputFunc="event => {
                                    this.reasonDetails.effect = event.target.value
                                }" />

                            <CustomInputRta type="select" id="respReason" :modelRef="reasonDetails.respAnalysisId"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Resp. Análise" :blue-class="true" :optList="usersResps" optValue="id"
                                optDisplay="name" :inputFunc="event => {
                                    this.reasonDetails.respAnalysisId = Number(event.target.value)
                                }" />

                            <CustomInputRta type="text" id="respReasonRole" :modelRef="reasonDetails.respRole"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Cargo do Responsável" :blue-class="true" :inputFunc="event => {
                                    this.reasonDetails.respRole = event.target.value
                                }" />

                            <CustomInputRta type="date" id="respReasonDate" :modelRef="reasonDetails.analysisDate"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Data da Análise" :blue-class="true" :inputFunc="event => {
                                    this.reasonDetails.analysisDate = event.target.value
                                }" />
                        </section>
                        <section class="methodsAllowed">
                            <b-tabs pills no-nav-style content-class="customTabsReasonContent"
                                class="customTabsReasonContainer">
                                <b-tab v-if="analysisType == 0 || analysisType == 2" title="6Ms de Ishikawa" active>
                                    <div :style="{ height: `${reasonTableHeight}px` }">
                                        <DealRtaTable :headers="ishikawaCols" :data="ishikawaData"
                                            :height="reasonTableHeight" @toDeleteItem="getLineToDelete" type="ishik"
                                            :show-action-acc="avaliateEfficActionType" :userPermission="pagePermissions"
                                            :efficFunc="handleEfficDeal" :respList="usersResps" />
                                    </div>
                                    <button @click="addReasonLine(0)" class="addLineTable">
                                        <b-icon-plus-circle-fill />
                                        <span>Adicionar Linha</span>
                                    </button>
                                </b-tab>
                                <b-tab v-if="analysisType == 0 || analysisType == 1" title="5 Porquês">
                                    <div :style="{ height: `${reasonTableHeight}px` }">
                                        <DealRtaTable :headers="porquesCols" :data="porquesData"
                                            :height="reasonTableHeight" @toDeleteItem="getLineToDelete" type="5pq"
                                            :show-action-acc="avaliateEfficActionType" :userPermission="pagePermissions"
                                            :efficFunc="handleEfficDeal" :respList="usersResps" />
                                    </div>
                                    <button @click="addReasonLine(1)" class="addLineTable">
                                        <b-icon-plus-circle-fill />
                                        <span>Adicionar Linha</span>
                                    </button>
                                </b-tab>
                            </b-tabs>
                        </section>

                    </b-tab>
                    <b-tab title="Elaboração do Plano de Ação">
                        <section class="respContainer">
                            <CustomInputRta type="select" id="actionResp" :modelRef="actionDetails.respActionId"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Resp. pelo Plano" :blue-class="true" :optList="usersResps" optValue="id"
                                optDisplay="name" :inputFunc="event => {
                                    this.actionDetails.respActionId = Number(event.target.value)
                                }" />

                            <CustomInputRta type="text" id="actionRespRole" :modelRef="actionDetails.respActionRole"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Cargo do Responsável" :blue-class="true" :inputFunc="event => {
                                    this.actionDetails.respActionRole = event.target.value
                                }" />

                            <CustomInputRta type="date" id="actionDate" :modelRef="actionDetails.actionDate"
                                :editable="pagePermissions.isActionReasonResp && disableEdit == false"
                                label="Data da Elaboração do Plano" :blue-class="true" :inputFunc="event => {
                                    this.actionDetails.actionDate = event.target.value
                                }" />
                        </section>
                        <div :style="{ height: `${actionTableHeight}px` }">
                            <DealRtaTable :headers="actionPlanCols" :data="actionPlanData" :height="actionTableHeight"
                                @toDeleteItem="getLineToDelete" type="actions"
                                :show-action-acc="avaliateEfficActionType" :userPermission="pagePermissions"
                                :efficFunc="handleEfficDeal" :respList="usersResps" />
                        </div>
                        <button @click="addActionLine" class="addLineTable">
                            <b-icon-plus-circle-fill />
                            <span>Adicionar Linha</span>
                        </button>
                    </b-tab>
                </b-tabs>
            </section>

            <section class="rtaBtnContainer">
                <div>
                    <button v-if="disableEdit == false && pagePermissions.canCancel && !pagePermissions.isManual"
                        class="cancelBtn" @click="() => handleSave(7)">
                        <b-icon-trash-fill />
                        <span>Cancelar RTA</span>
                    </button>
                    <button v-if="false" class="reopenBtn">
                        <b-icon-reply-fill />
                        <span>Reabrir RTA</span>
                    </button>
                </div>
                <div>
                    <button v-if="avaliateEfficActionType == 1 && pagePermissions.canAvaliate" class="accBtn">
                        <span>Avaliar Plano de Ação</span>
                    </button>
                    <button v-if="pagePermissions.canAvaliate" class="accBtn"
                        @click="() => handleEfficDeal('rta', this.detailsRta.id)">
                        <span>Avaliar RTA</span>
                    </button>
                    <button v-if="pagePermissions.canFinish && disableEdit == false" class="doneBtn"
                        @click="handleSave(6)">
                        <b-icon-check-circle-fill />
                        <span>Concluir RTA</span>
                    </button>
                    <button v-if="disableEdit == false" class="saveBtn" @click="() => handleSave(null)">
                        <img :src="require('@/assets/rta/save-svg.svg')" alt="Save RTA" />
                        <span>Salvar</span>
                    </button>
                </div>
            </section>
        </section>
        <b-modal id="fcaViewModal" size="xl" hide-footer title="Visualizar Indicadores Vinculados"
            v-if="pagePermissions.isManual == false">
            <span v-if="relatedIndicators.length == 0 || detailsRta.relatedfca == 0">Nenhuma ocorrência ou indicador
                vinculado.</span>
            <div v-if="relatedIndicators.length > 0 && detailsRta.relatedfca > 0">
                <CustomInputRta type="select" id="relatedInd" :modelRef="relatedSelected" :editable="true"
                    label="Indicador Vinculado" :blue-class="true" :optList="relatedIndicators" optValue="indicatorId"
                    optDisplay="indicatorName" :inputFunc="event => {
                        relatedSelected.id = event.target.value;
                        relatedSelected.indicatorId = event.target.value;
                    }" />

                <ManageAllOccurrences v-if="relatedSelected != null && detailsRta.relatedfca > 0" :viewMode="true"
                    :indicatorInfo="relatedSelected" :occurrenceInfo="relatedSelected" :reloadOccFunct="() => { }" />
            </div>
        </b-modal>

        <b-modal id="rtaGeneralEfficModal" size="xl" hide-footer title="Avaliação de Eficácia">
            <EfficiencyForm :evidence-is-required="true" :resp-list="usersResps" :detailsRta="detailsRta"
                :efficrelatedid="effitCRelatedId" :effitCtype="effitCtype" />
        </b-modal>

        <b-modal id="rtaDealDelete" title="Remover Linha" hide-footer>
            <p>Deseja realmente excluir essa linha?</p>
            <p>Lembrando que, caso queira reverter a exclusão, basta não clicar no
                botão "Salvar".</p>
            <RtaModalButtons :cancel-func="() => this.$bvModal.hide('rtaDealDelete')" :ok-func="handleDeleteLine" />
        </b-modal>
    </section>
</template>

<script>
import ManageAllOccurrences from '../manageAllOccurrences/ManageAllOccurrences.vue';
import CustomInputRta from './commons/CustomInputRta.vue';
import DealRtaTable from './commons/DealRtaTable.vue';
import EfficiencyForm from './commons/EfficiencyForm.vue';
import RtaModalButtons from './commons/RtaModalButtons.vue';
import axios from '../../../node_modules/axios/index';
import { urlMainAPI, defaultSuccess, showError } from '../../global';
import * as moment from 'moment';
import { mapState } from "vuex";
import { v4 as uuidv4 } from 'uuid';
export default {
    name: "RTADetails",
    components: { CustomInputRta, ManageAllOccurrences, DealRtaTable, EfficiencyForm, RtaModalButtons },
    computed: {
        ...mapState(["user"]),
        allActionsEvaluated() {
            const mandatory = this.actionPlanData.filter(ac => ac.actionType === "obrigatorio");
            if (mandatory.length === 0) return true;
            return mandatory.every(ac => this.actionValidated[ac.contextId]);
        }
    },
    props: ["isManual"],
    data() {
        return {
            validatingActions: false,
            actionValidated: {},
            loadedHasReason: false,
            loadedHasActions: false,
            loading: false,
            lineToDelete: null,
            showDetailsInfo: true,
            actionTableHeight: 140,
            reasonTableHeight: 120,
            relatedIndicators: [],
            relatedSelected: null,
            occurrenceStructureMock: {},
            pagePermissions: {
                isManualRta: false,
                isMainResp: false,
                isAuxResp: false,
                isActionReasonResp: false,
                canFinish: false,
                canAvaliate: false,
                canCancel: false,
            },
            effitCtype: null,
            effitCRelatedId: null,
            disableEdit: false,
            usersResps: [],
            process: [],
            products: [],
            equipment: [],
            allIndicators: [],
            avaliateEfficActionType: 0,
            analysisType: 0,
            detailsRta: {
                code: "",
                indicatorName: "",
                processId: null,
                productId: null,
                equipmentId: null,
                mainRespId: null,
                creationDate: "",
                deadline: "",
                triggerName: "",
                efficiencyRespId: null,
                auxResps: [],
                desc: "",
            },

            reasonDetails: {
                effect: "",
                respAnalysisId: null,
                respRole: "",
                analysisDate: ""
            },

            actionDetails: {
                respActionId: null,
                respActionRole: "",
                actionDate: ""
            },

            actionPlanCols: [
                { field: "mainReason", key: "mainReason", title: "Causa Fundamental", align: "center", edit: true, width: "8%", ellipsis: { lineClamp: 2 } },
                { field: "what", key: "what", title: "O Que (Ação)", align: "center", edit: true, width: "8%", ellipsis: { lineClamp: 2 } },
                { field: "how", key: "how", title: "Como (Etapa)", align: "center", edit: true, width: "8%", ellipsis: { lineClamp: 2 } },
                { field: "where", key: "where", title: "Onde (Processo)", align: "center", edit: true, width: "8%", ellipsis: { lineClamp: 2 } },
                { field: "howMuch", key: "howMuch", title: "Quanto", align: "center", edit: true, width: "8%", ellipsis: { lineClamp: 2 } },
                { field: "who", key: "who", title: "Responsável", align: "center", edit: false, width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "whenInitPrev", key: "whenInitPrev", title: "Início Previsto", align: "center", width: "5%", edit: false, ellipsis: { lineClamp: 1 } },
                { field: "whenFinishPrev", key: "whenFinishPrev", title: "Término Previsto", align: "center", width: "5%", edit: false, ellipsis: { lineClamp: 1 } },
                { field: "whenInitReal", key: "whenInitReal", title: "Início Real", align: "center", width: "5%", edit: false, ellipsis: { lineClamp: 1 } },
                { field: "whenFinishReal", key: "whenFinishReal", title: "Término Real", align: "center", width: "5%", edit: false, ellipsis: { lineClamp: 1 } },
                { field: "actionType", key: "actionType", title: "Tipo", align: "center", edit: false, width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "actionStatus", key: "actionStatus", title: "Status", align: "center", edit: false, width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "actionAcc", key: "actionAcc", title: "Eficácia", align: "center", edit: false, width: "8%", ellipsis: { lineClamp: 1 } },
                { field: "actionDelete", key: "actionDelete", title: "Remover", align: "center", width: "8%", edit: false, ellipsis: { lineClamp: 1 } },
            ],
            actionPlanData: [],

            ishikawaCols: [
                { field: "sixm", key: "sixm", title: "6Ms", align: "center", edit: false, width: "11%", ellipsis: { lineClamp: 1 } },
                { field: "firstCause", key: "firstCause", title: "Causa Primária", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "secondCause", key: "secondCause", title: "Causa Secundária", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "thirdCause", key: "thirdCause", title: "Causa Terciária", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "fourthCause", key: "fourthCause", title: "Causa Quaternária", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "fifthCause", key: "fifthCause", title: "Causa Quintenária", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "sixthCause", key: "sixthCause", title: "Causa Sextenária", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "mainCause", key: "mainCause", title: "Causa Fundamental", align: "center", edit: true, width: "11%", ellipsis: { lineClamp: 2 } },
                { field: "actionDelete", key: "actionDelete", title: "Remover", align: "center", edit: false, width: "11%", ellipsis: { lineClamp: 1 } },
            ],
            ishikawaData: [],

            porquesCols: [
                { field: "firstPq", key: "firstPq", title: "Primeiro Porquê", align: "center", edit: true, width: "12%", ellipsis: { lineClamp: 2 } },
                { field: "secondPq", key: "secondPq", title: "Segundo Porquê", align: "center", edit: true, width: "12%", ellipsis: { lineClamp: 2 } },
                { field: "thirdPq", key: "thirdPq", title: "Terceiro Porquê", align: "center", edit: true, width: "12%", ellipsis: { lineClamp: 2 } },
                { field: "fourthPq", key: "fourthPq", title: "Quarto Porquê", align: "center", edit: true, width: "12%", ellipsis: { lineClamp: 2 } },
                { field: "fifthPq", key: "fifthPq", title: "Quinto Porquê", align: "center", edit: true, width: "12%", ellipsis: { lineClamp: 2 } },
                { field: "mainCause", key: "mainCause", title: "Causa Fundamental", align: "center", edit: true, width: "12%", ellipsis: { lineClamp: 2 } },
                { field: "actionDelete", key: "actionDelete", title: "Remover", align: "center", edit: false, width: "12%", ellipsis: { lineClamp: 1 } },
            ],
            porquesData: [],
        }
    },
    methods: {
        async validateAllActions() {
            this.validatingActions = true;
            const mandatory = this.actionPlanData.filter(ac => ac.actionType === "obrigatorio");
            const checks = mandatory.map(ac => {
                const url = `${urlMainAPI}/getefficiencyrta/${this.detailsRta.id}/action/${ac.contextId}`;
                return axios.get(url)
                    .then(res => ({ id: ac.contextId, valid: res.data.effic !== null }))
                    .catch(() => ({ id: ac.contextId, valid: false }));
            });
            const results = await Promise.all(checks);
            this.actionValidated = {};
            results.forEach(r => { this.actionValidated[r.id] = r.valid });
            this.validatingActions = false;
        },

        showWarn(msg) {
            this.$bvToast.toast(msg, {
                title: 'Atenção',
                variant: 'warning',
                toaster: 'b-toaster-bottom-left',
                solid: true
            });
        },

        addActionLine() {
            this.actionPlanData.push({
                mainReason: "", what: "", how: "", where: "", howMuch: "", who: "", whenInitPrev: "", whenFinishPrev: "", whenInitReal: "", whenFinishReal: "",
                actionType: "", actionStatus: "", actionAcc: "", actionDelete: "", rowKey: Date.now() + Math.random(), contextId: uuidv4()
            })
        },

        validateRequiredFields() {
            if (this.detailsRta.indicatorId == null ||
                this.detailsRta.mainRespId == null ||
                this.detailsRta.processId == null ||
                this.detailsRta.efficiencyRespId == null ||
                this.detailsRta.formattedDeadline == "" ||
                this.detailsRta.formattedCreationDate == ""
            ) {
                return false;
            }
            return true;
        },

        allActionsComplete() {
            let res = true;

            if (this.actionPlanData.length > 0) {
                this.actionPlanData.forEach(ac => {
                    if (ac.actionType == "obrigatorio" && ac.actionStatus != "finished") res = false
                })
            }

            return res;
        },

        async handleEfficDeal(type, id) {
            if (type === 'rta') {
                if (!this.loadedHasReason || !this.loadedHasActions) {
                    this.showWarn("Salve Causa Raiz e Plano antes de avaliar RTA"); return;
                }

                if (!this.allActionsComplete()) {
                    this.showWarn("Finalize ações obrigatórias antes de avaliar RTA"); return;
                }

                if (this.avaliateEfficActionType === 0) {
                    await this.validateAllActions();
                    if (!this.allActionsEvaluated) {
                        this.showWarn("Avalie todas as ações antes de avaliar RTA"); return;
                    }
                }
            }

            this.effitCtype = type;
            this.effitCRelatedId = id;

            this.$bvModal.show('rtaGeneralEfficModal')
        },

        toggleDetailsInfo() {
            this.showDetailsInfo = !this.showDetailsInfo;
            this.changeTableSizes();
        },

        changeTableSizes() {
            if (this.showDetailsInfo == false) {
                if (window.innerWidth > 1600) {
                    this.actionTableHeight = 430;
                    this.reasonTableHeight = 410;
                } else {
                    this.actionTableHeight = 232;
                    this.reasonTableHeight = 210;
                }
            } else {
                if (window.innerWidth > 1600) {
                    this.actionTableHeight = 330;
                    this.reasonTableHeight = 310;
                } else {
                    this.actionTableHeight = 130;
                    this.reasonTableHeight = 105;
                }
            }
        },

        onResize() {
            this.changeTableSizes();
        },

        addReasonLine(listType) {
            if (listType == 0) {
                this.ishikawaData.push({
                    sixm: '',
                    firstCause: '',
                    secondCause: '',
                    thirdCause: '',
                    fourthCause: '',
                    fifthCause: '',
                    sixthCause: '',
                    mainCause: '',
                    actionDelete: '',
                    rowKey: Date.now() + Math.random()
                });
            }
            else if (listType == 1) {
                this.porquesData.push({
                    firstPq: '',
                    secondPq: '',
                    thirdPq: '',
                    fourthPq: '',
                    fifthPq: '',
                    mainCause: '',
                    actionDelete: '',
                    rowKey: Date.now() + Math.random()
                })
            }
        },

        handleDeleteLine() {
            if (this.lineToDelete.type == 'actions') {
                this.actionPlanData = this.filterDelete(this.actionPlanData, this.lineToDelete.data.rowKey)
            } else if (this.lineToDelete.type == 'ishik') {
                this.ishikawaData = this.filterDelete(this.ishikawaData, this.lineToDelete.data.rowKey)
            } else if (this.lineToDelete.type == '5pq') {
                this.porquesData = this.filterDelete(this.porquesData, this.lineToDelete.data.rowKey)

            }

            this.$bvModal.hide('rtaDealDelete')
        },

        getLineToDelete(item) {
            this.lineToDelete = item;
        },

        filterDelete(array, id) {
            if (array.length > 0) {
                return array.filter(i => i.rowKey != id);
            } else {
                return array
            }
        },

        async loadUsers() {
            await axios.get(`${urlMainAPI}/getusers`)
                .then(res => {
                    this.usersResps = res.data;
                }).catch(err => console.error(err))
        },

        async loadProductionInfos() {
            await axios.get(`${urlMainAPI}/getproductioninfos`)
                .then(res => {
                    this.process = res.data.allProcess;
                    this.products = res.data.allProducts;
                    this.equipment = res.data.allEquipment;
                    this.allIndicators = res.data.allIndicators;
                }).catch(err => console.error(err))
        },

        async getDealingReasonActionTables() {
            if (this.detailsRta.id == -9999) return;
            await axios.get(`${urlMainAPI}/getdealingtablesrta/${this.detailsRta.id}`)
                .then(res => {
                    let reasons = res.data.reasons;
                    let actions = res.data.actions;


                    this.reasonDetails = {
                        dealingId: reasons.id,
                        effect: reasons.effect,
                        respAnalysisId: reasons.analysisResponsibleId,
                        respRole: reasons.analysisResponsibleRole,
                        analysisDate: reasons.analysisDate ? moment(reasons.analysisDate).format("YYYY-MM-DD") : moment(Date.now()).format("YYYY-MM-DD"),
                        deafultDate: reasons.analysisDate,
                    }

                    this.actionDetails = {
                        dealingId: actions.id,
                        respActionId: actions.actionPlanResponsibleId,
                        respActionRole: actions.actionPlanResponsibleRole,
                        actionDate: actions.actionPlanDate ? moment(actions.actionPlanDate).format("YYYY-MM-DD") : moment(Date.now()).format("YYYY-MM-DD"),
                        deafultDate: actions.actionPlanDate,
                    }


                    if (actions.tableContent != "") {
                        let content = JSON.parse(actions.tableContent)

                        if (content.actions) {
                            this.actionPlanData = [...content.actions]
                        }
                    }

                    if (reasons.tableContent != "") {
                        let content = JSON.parse(reasons.tableContent)

                        if (content.ishikawa) this.ishikawaData = [...content.ishikawa];
                        if (content.fivepq) this.porquesData = [...content.fivepq];
                    }

                    this.loadedHasReason = this.ishikawaData.length > 0 || this.porquesData.length > 0;
                    this.loadedHasActions = this.actionPlanData.length > 0;

                    console.log("deal: ", res)
                    defaultSuccess("Relatórios Carregados com Sucesso!")

                })
                .catch(() => showError("Falha ao Carregar Relatórios."))
        },

        async loadDealingIdsOnly() {
            if (this.detailsRta.id == -9999) return;

            try {
                const res = await axios.get(`${urlMainAPI}/getdealingtablesrta/${this.detailsRta.id}`);
                const reasons = res.data.reasons;
                const actions = res.data.actions;

                this.reasonDetails = { ...this.reasonDetails, dealingId: reasons.id };
                this.actionDetails = { ...this.actionDetails, dealingId: actions.id };

                defaultSuccess("IDs de Dealing carregados com sucesso!");

            } catch {
                showError("Falha ao carregar IDs de Dealing.");
            }
        },

        async saveDealingReasonActionTables() {
            let actionsObj = {
                dealingId: this.actionDetails.dealingId,
                rtaId: this.detailsRta.id,
                tableType: 0,
                respId: this.actionDetails.respActionId,
                respRole: this.actionDetails.respActionRole,
                tableDate: this.actionDetails.deafultDate != "" ? moment(this.actionDetails.deafultDate) : moment(Date.now()),
                tableAggregationContent: JSON.stringify({ actions: [...this.actionPlanData] })
            }

            let reasons = {
                dealingId: this.reasonDetails.dealingId,
                rtaId: this.detailsRta.id,
                effect: this.reasonDetails.effect,
                tableType: 1,
                respId: this.reasonDetails.respAnalysisId,
                respRole: this.reasonDetails.respRole,
                tableDate: this.reasonDetails.deafultDate != "" ? moment(this.reasonDetails.deafultDate) : moment(Date.now()),
                tableAggregationContent: JSON.stringify({
                    ishikawa: [...this.ishikawaData],
                    fivepq: [...this.porquesData]
                })
            }

            if (this.isManual == true) {
                actionsObj.rtaId = this.detailsRta.id;
                reasons.rtaId = this.detailsRta.id;
            }

            await axios.post(`${urlMainAPI}/savedealingtablesrta`, [actionsObj, reasons])
                .then(() => defaultSuccess("Relatórios Armazenados com Sucesso!")
                )
                .catch(() => showError("Falha ao Armazenar Relatórios."))
        },

        async saveGeneralInformation(status = null) {
            if (typeof this.detailsRta.creationDate == "number") this.detailsRta.creationDate = new Date(this.detailsRta.creationDate).toISOString()
            if (typeof this.detailsRta.deadline == "number") this.detailsRta.deadline = new Date(this.detailsRta.deadline).toISOString()


            if (this.isManual == true) {
                this.detailsRta.deadline = new Date(this.detailsRta.formattedDeadline).toISOString();
                this.detailsRta.creationDate = new Date(this.detailsRta.formattedCreationDate).toISOString();
                this.detailsRta.workshiftId = 4;
                this.detailsRta.triggerId = 11;
            }

            let objToSave = {
                id: this.detailsRta.id,
                rtaCode: this.detailsRta.code,
                indicatorId: this.detailsRta.indicatorId,
                processId: this.detailsRta.processId,
                workshiftId: this.detailsRta.workshiftId,
                productId: this.detailsRta.productId,
                equipmentId: this.detailsRta.equipmentId,
                triggerId: this.detailsRta.triggerId,
                creationDate: this.detailsRta.creationDate,
                deadline: this.detailsRta.deadline,
                description: this.detailsRta.desc,
                actionPlanResponsibleId: this.detailsRta.mainRespId,
                accuracyResponsibleid: this.detailsRta.efficiencyRespId,

                target: 0,
                value: 0,
                lowerLimit: 0,
                upperLimit: 0,

                status: 0,
            }

            let today = Date.now();
            let [datePart, timePart] = this.detailsRta.deadline.split(" ");
            let deadline = new Date(`${datePart}T${timePart}Z`).getTime()

            if (this.reasonDetails.respAnalysisId) {
                if (today > deadline) {
                    objToSave.status = 2;
                } else {
                    objToSave.status = 1;
                }
            }

            if (this.actionDetails.respActionId) {
                if (today > deadline) {
                    objToSave.status = 4;
                } else {
                    objToSave.status = 3;
                }
            }

            if (status != null) {
                objToSave.status = status;
            }

            await axios.post(`${urlMainAPI}/saverta/${false}`, [objToSave]).then((res) => {
                const saved = res.data[0];
                this.detailsRta.statusId = saved.statusId;
                if (saved.statusId == 6 || saved.statusId == 7) this.disableEdit = true;
                this.detailsRta = { ...this.detailsRta, id: saved.id, rtaCode: saved.rtaCode, code: saved.rtaCode }
                sessionStorage.setItem("currentRTA", JSON.stringify(this.detailsRta));
                defaultSuccess("RTA Atualizada com Sucesso!");
            }).catch(() => showError("Falha ao Atualizar RTA."))
        },

        async handleSave(status = null) {
            if (this.actionPlanData.length > 0 && (!this.actionDetails.respActionId || this.actionDetails.respActionId === 0)) {
                this.$bvToast.toast("Selecione um Responsável pelos planos de ações cadastrados antes de salvar RTA.",
                    {
                        title: "Responsável não definido!",
                        variant: "warning",
                        toaster: "b-toaster-bottom-left",
                        solid: true,
                    }
                );
                return;
            }

            const totalCausas = this.ishikawaData.length + this.porquesData.length;
            if (totalCausas > 0 && (!this.reasonDetails.respAnalysisId || this.reasonDetails.respAnalysisId === 0)) {
                this.$bvToast.toast("Selecione um Responsável pela Análise da Causa Raiz antes de salvar RTA.", {
                    title: "Responsável não definido!",
                    variant: "warning",
                    toaster: "b-toaster-bottom-left",
                    solid: true,
                });
                return;
            }

            if (!this.validateRequiredFields()) {
                this.$bvToast.toast("Preencha os campos do detalhamento antes de salvar.", {
                    title: "Campos obrigatórios em branco!",
                    variant: "warning",
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                });
                return;
            }

            if (status === 6) {
                if (!this.loadedHasReason || !this.loadedHasActions) {
                    this.showWarn("Salve uma Causa Raiz e um Plano de Ação antes de concluir a RTA");
                    return;
                }

                if (!this.allActionsComplete()) {
                    this.$bvToast.toast("Finalize todas as ações obrigatórias antes de finalizar.", {
                        title: "Ações Obrigatórias Pendentes!",
                        variant: "warning",
                        toaster: 'b-toaster-bottom-left',
                        solid: true
                    });
                    return;
                }

                if (this.avaliateEfficActionType === 0) {
                    await this.validateAllActions();
                    if (!this.allActionsEvaluated) {
                        this.showWarn("Avalie todas as ações obrigatórias antes de concluir a RTA");
                        return;
                    }
                }
            }

            this.loading = true;
            await this.saveGeneralInformation(status);
            await this.loadDealingIdsOnly();
            await this.saveDealingReasonActionTables();
            this.loading = false;
        },

        async loadGeneralConfig() {
            await axios.get(`${urlMainAPI}/getGeneralConfigGerencialIndicators`)
                .then(res => {
                    if (res.data) {
                        this.avaliateEfficActionType = res.data.actionPlanRating;
                        this.analysisType = res.data.analysesMetd;
                    }
                })
                .catch(err => {
                    this.stopLoading();
                    console.error(err)
                })

            if (this.avaliateEfficActionType != 0) {
                this.actionPlanCols = this.actionPlanCols.filter(item => item.field != "actionAcc");
            }
        },

        async loadRelatedIndicatorId() {
            if (this.detailsRta.indicatorId == null) return;

            await axios.get(`${urlMainAPI}/getrelatedrtaindicatorlist/${this.detailsRta.indicatorId}`)
                .then(res => {
                    if (res.data && res.data.length) {
                        this.relatedIndicators = [...res.data]
                        this.relatedSelected = { id: this.relatedIndicators[0].indicatorId, indicatorId: this.relatedIndicators[0].indicatorId, description: "", actionsList: [], content: { actionsList: [] } };
                    }
                })
                .catch(err => console.error(err))
        },

        validatePermissions() {
            let permissions = { ...this.user.Permissions };

            if (permissions.rtacriarmanualmente && permissions.rtacriarmanualmente.allowed == true && this.isManual) {
                this.pagePermissions.isManual = true;
                this.pagePermissions.isMainResp = true;
                this.pagePermissions.isAuxResp = true;
                this.pagePermissions.isActionReasonResp = true;
                this.pagePermissions.canFinish = true;
                this.pagePermissions.canAvaliate = true;
                this.pagePermissions.canCancel = true;
                return;
            }

            if (permissions.rtacancelar && permissions.rtacancelar.allowed == true) this.pagePermissions.canCancel = true;

            if (permissions.rtaeficacia && permissions.rtaeficacia.allowed == true) {
                if (this.detailsRta.efficiencyRespId && this.user.Id == this.detailsRta.efficiencyRespId.toString()) this.pagePermissions.canAvaliate = true;
            }

            if (permissions.rtacausaraizeacao && permissions.rtacausaraizeacao.allowed == true) {
                if (this.reasonDetails.respAnalysisId && this.actionDetails.respActionId && (this.user.Id == this.reasonDetails.respAnalysisId.toString() || this.user.Id == this.actionDetails.respActionId.toString())) {
                    this.pagePermissions.isActionReasonResp = true;
                }
            }

            if (this.detailsRta.mainRespId && this.user.Id == this.detailsRta.mainRespId.toString()) this.pagePermissions.isMainResp = true;

            if (this.detailsRta.auxResponsibles && this.detailsRta.auxResponsibles != "" && this.detailsRta.auxResponsibles != "Não encontrado.") {
                this.detailsRta.auxResponsibles.forEach(
                    ux => {
                        if (ux.UserId.toString() == this.user.Id) this.pagePermissions.isAuxResp = true;
                    }
                );
            }

            if (permissions.rtageral && permissions.rtageral.allowed == true) {
                this.pagePermissions.isMainResp = true;
                this.pagePermissions.isAuxResp = true;
                this.pagePermissions.isActionReasonResp = true;
                this.pagePermissions.canFinish = true;
                this.pagePermissions.canAvaliate = true;
                this.pagePermissions.canCancel = true;
            }

            this.pagePermissions.isManualRta = this.isManual;
        },
    },
    async mounted() {
        this.loading = true;

        if (!this.$route.params.rtaData || this.$route.params.rtaData == undefined) {
            let rtaStorage = sessionStorage.getItem("currentRTA");

            if (this.isManual == true || rtaStorage == undefined) {
                sessionStorage.removeItem("currentRTA");
                this.detailsRta = {
                    id: -9999,
                    code: "",
                    desc: "",
                    creationDate: Date.now(),
                    formattedCreationDate: "",
                    status: "",
                    indicatorId: null,
                    indicator: "",
                    processId: null,
                    process: "",
                    productId: null,
                    product: "",

                    equipmentId: null,
                    equipment: "",
                    triggerId: "",
                    trigger: "MAN",
                    mainRespId: null,
                    responsible: "",

                    efficiencyRespId: null,
                    efficiencyRespName: "",

                    auxResponsibles: "",

                    relatedRtaId: null,
                    workshiftId: null,
                    workshift: "",

                    value: 0,
                    target: 0,
                    deadline: Date.now(),
                    formattedDeadline: "",

                    efficiencyrta: "",
                    efficiencyaction: "",

                    relatedfca: 0
                }
            } else {
                this.detailsRta = { ...JSON.parse(rtaStorage) };
                if (this.detailsRta.statusId == 6 || this.detailsRta.statusId == 7) this.disableEdit = true;
            }
        } else {
            this.detailsRta = this.$route.params.rtaData;
            if (this.detailsRta.description == "" || this.detailsRta.description == null || this.detailsRta.description == undefined) {
                this.detailsRta.desc = `No dia ${moment(this.detailsRta.creationDate).format("DD/MM/YYYY")} do turno ${this.detailsRta.workshift}, o indicador ${this.detailsRta.indicator}, referente ao processo ${this.detailsRta.process}, ao equipamento ${this.detailsRta.equipment} e ao produto ${this.detailsRta.product}, gerou uma RTA pelo gatilho ${this.detailsRta.trigger} para o responsável ${this.detailsRta.responsible}.`
            } else {
                this.detailsRta.desc = this.detailsRta.description;
            }

            this.detailsRta.auxResponsibles = this.detailsRta.auxResponsibles == "" || this.detailsRta.auxResponsibles == "Não encontrado." || this.detailsRta.auxResponsibles == "-" ? "" : JSON.parse(this.detailsRta.auxResponsibles);

            if (this.detailsRta.statusId == 6 || this.detailsRta.statusId == 7) this.disableEdit = true;

            sessionStorage.setItem("currentRTA", JSON.stringify(this.detailsRta))
        }

        this.changeTableSizes();
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });

        await this.loadRelatedIndicatorId();

        await this.loadUsers();
        await this.loadProductionInfos();
        await this.loadGeneralConfig();

        await this.getDealingReasonActionTables();

        this.validatePermissions();

        console.log("edit: ", this.detailsRta)
        console.log("edit: ", this.disableEdit)

        this.loading = false;
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
}
</script>

<style>
.customTabsClassContainerRta {
    border-width: 0 1px 1px 1px;
    border-color: #dee2e6;
    border-style: solid;
    border-radius: 0.1rem;
    padding: 0.5rem;
}

.customTabsClassRta li {
    color: #008787;
}

.customTabsClassRta li a {
    border-color: #DCDCDC !important;

    background-color: #F2F2F2 !important;
    color: #969B9B !important;
}

.customTabsClassRta li a[aria-selected="true"] {
    color: #00A39F !important;
    background-color: #fff !important;
}

.showDetailsBtn {
    width: 100%;
    font-weight: 500;
    font-size: 0.8rem;
    border: none;
    background-color: transparent;
    color: #c2c2c2;
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 0.2rem;
    white-space: nowrap;
}

.showDetailsBtn::before,
.showDetailsBtn::after {
    content: "";
    display: block;
    height: 1px;
    width: 80%;
    background-color: #c2c2c2;
}

.customTabsReasonContainer li {
    padding: 0;
    margin: 0.3rem 0.4rem;
    text-align: center;
}

.customTabsReasonContainer li a {
    border: 1px solid #949494;
    border-radius: 0.3rem;
    background-color: #ffffff !important;
    color: #909090;
    padding: 0.2rem 0.3rem !important;
}

.customTabsReasonContainer li a[aria-selected="true"] {
    border-color: #046FDB !important;
    color: #046FDB !important;
    background-color: #fff !important;
}
</style>

<style scoped>
.rtaTitle {
    padding-bottom: 0.3rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    border-bottom: 1px solid #c7c7c7;
}

.rtaTitle img {
    height: 30px;
}

.rtaTitle span {
    font-weight: 600;
    font-size: 1.3rem;
}

.rtaDetailsContainer {
    /* display: grid;
    grid-template-rows: 6rem 3rem max-content max-content;
    row-gap: 0.5rem;
    height: max-content; */

    padding: 0.3rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 0.2rem;
}

.respContainer {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 0.8rem;
    padding-top: 0.5rem;
}

.openFcas {
    display: flex;
    column-gap: 0.5rem;
    max-height: 3rem;
}


.openFcas button {
    background-color: #FF5F00;
    color: #fff;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
    font-weight: 600;
    font-size: 0.8rem;
}

.addLineTable {
    width: 100%;
    background-color: #91E5E5;
    color: #008787;
    text-align: center;
    border: none;
    padding: 0.2rem;
    border-radius: 0.2rem;
    margin-top: 0.4rem;
}

.addLineTable span {
    margin-left: 0.3rem;
}

.rtaBtnContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.rtaBtnContainer div {
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
}

.rtaBtnContainer button {
    border: 1px solid #000;
    border-radius: 0.2rem;
    font-weight: 500;
    background-color: #fff;
    padding: 0.3rem 0.4rem;
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
}

.rtaBtnContainer .cancelBtn {
    color: #D21724;
    border-color: #D21724;
}

.rtaBtnContainer .accBtn {
    color: #008787;
    border-color: #008787;
}

.rtaBtnContainer .doneBtn {
    color: #FF7122;
    border-color: #FF7122;
}

.rtaBtnContainer .saveBtn {
    color: #fff;
    border-color: #FF7122;
    background-color: #FF7122;
}

.rtaBtnContainer .reopenBtn {
    color: #fff;
    border-color: #008787;
    background-color: #008787;
}

.heightContainer {
    height: 100%;
}

.methodsAllowed {
    width: 100%;
}

.generalInfo {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0.5rem;
    grid-row-gap: 0.5rem;
}

.code {
    grid-area: 1 / 1 / 2 / 2;
}

.ind {
    grid-area: 1 / 2 / 2 / 3;
}

.proc {
    grid-area: 1 / 3 / 2 / 4;
}

.prod {
    grid-area: 1 / 4 / 2 / 5;
}

.resp {
    grid-area: 1 / 5 / 2 / 6;
}

.auxResp {
    grid-area: 1 / 6 / 3 / 8;
    position: relative;
    border: 1px solid #C7C7C7;
    border-radius: 0.2rem;
}

.auxResp span {
    position: absolute;
    padding: 0.2rem;
    background-color: white;
    color: #FF5F00;
    font-size: 0.8rem;

    top: -.8rem;
    left: 0.4rem;
}

.auxResp div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    row-gap: 0.3rem;
    max-height: 6rem;
    overflow-y: auto;
    margin-top: 0.8rem;
}

.auxResp div p {
    margin: 0;
    padding: 0.1rem;
    font-size: 0.9rem;
    color: #272727;
    background-color: #f3f3f3;
    border-radius: 0.2rem;
}

.creation {
    grid-area: 2 / 1 / 3 / 2;
}

.deadline {
    grid-area: 2 / 2 / 3 / 3;
}

.equip {
    grid-area: 2 / 3 / 3 / 4;
}

.trigger {
    grid-area: 2 / 4 / 3 / 5;
}

.accResp {
    grid-area: 2 / 5 / 3 / 6;
}
</style>